import React, { useEffect, useState, useRef } from "react";
import {
  Table,
  Input,
  message,
  Button,
  Space,
  Spin,
  Typography,
  notification,
  Modal,
  Card,
  Tooltip,
  Alert,
  Select,
  Row,
  Col,
  Statistic,
  Grid,
} from "antd";
import {
  SearchOutlined,
  FilePdfOutlined,
  EditOutlined,
  ClearOutlined,
  PlusOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import getVisitaTecnicaById from "../../../services/visitas_tecnicas/visita_tecnica/getVisitaTecnicaByIdService";
import { selectAppPermissions } from "../../../store/auth/selectors";
import FormularioVisitaTecnicaSostenibilidad from "./FormVisitaTecnicaSostenibilidad";
import PdfVisitaTecnicaSostenibilidad from "./pdfVisitaTecnicaSostenibilidad";
import Header166 from "../../header/header";
import {
  getVisitasTecnicasSostenibilidad,
  getVisitaTecnicaSostenibilidadById,
} from "../../../services/sostenibilidad/visitaTecnicaSostenibilidad/viistaTecnicaSostenibilidadService";
import ExportVisitasTecnicasSostenibilidad from "./VisitasTecnicasSostenibilidadExcel";

const { Text, Title } = Typography;
const { Option } = Select;

const TablaVisitaTecnicaSostenibilidad = () => {
  const [visitasTecnicas, setVisitasTecnicas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const [showForm, setShowForm] = useState(false); // Estado para controlar la visibilidad del formulario

  // ✅ Vista de página en lugar de modal/drawer: evita problemas al rotar el dispositivo
  const [showFormModal, setShowFormModal] = useState(false);

  
  const [initialData, setInitialData] = useState({}); // Estado para manejar los datos iniciales

  const [showPdfVisitasTecnicas, setShowPdfVisitasTecnicas] = useState(false); // Estado para mostrar el componente pdfVisitasTecnicas

  const [departamentos, setDepartamentos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [modalidad, setModalidad] = useState([]);

  const [selectedDepartamento, setSelectedDepartamento] = useState(null);
  const [selectedMunicipio, setSelectedMunicipio] = useState(null);
  const [selectedModalidad, setSelectedModalidad] = useState(null);

  const appName = "visitas-tecnicas-sostenibilidad";
  const permissions = useSelector((state) =>
    selectAppPermissions(state, appName)
  );
  const permissionInsert = permissions.priv_insert === "Y";
  const permissionUpdate = permissions.priv_update === "Y";
  const permissionExport = permissions.priv_export === "Y";
  const permissionPrint = permissions.priv_print === "Y";

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const { useBreakpoint } = Grid;
const screens = useBreakpoint();
const isMobile = !screens.md;

  const handleCancel = () => {
    if (initialData && Object.keys(initialData).length > 0) {
      Modal.confirm({
        title: "¿Está segur@ de que desea cerrar?",
        content:
          "Si cierra esta ventana, la información ingresada no se guardará.",
        okText: "Sí, cerrar",
        cancelText: "No",
        onOk: () => {
          handleCloseModal(false);
          setInitialData({});
        },
      });
    } else {
      Modal.confirm({
        title: "¿Está segur@ de que desea cerrar?",
        content:
          "Si cierra esta ventana, la información ingresada no se guardará.",
        okText: "Sí, cerrar",
        cancelText: "No",
        onOk: () => {
          handleCloseModal(false);
          setInitialData({});
        },
      });
    }
  };
  const fetchVisitasTecnicas = async () => {
    try {
      const response = await getVisitasTecnicasSostenibilidad();
      const { status, data } = response;

      if (status === 200) {
        setVisitasTecnicas(data);
        setFilteredData(data || []);
      } else {
        setVisitasTecnicas([]);
        setFilteredData([]);
        notification.error({
          message: "Error",
          description:
            typeof message === "string"
              ? message
              : "Failed to fetch visitas técnicas de sostenibilidad data.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    } finally {
      setLoading(false);
    }
  };
  const fetchVisitaTecnicaById_update = async (id) => {
    try {
      const response = await getVisitaTecnicaSostenibilidadById(id);
      const { status, data } = response;

      if (status) {
        setInitialData(data);
        handleOpenModal(true); // Abre el modal
      } else {
        notification.error({
          message: "Error",
          description:
            typeof response.message === "string"
              ? response.message
              : "Failed to fetch visita técnica data.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    }
  };
  const fetchVisitaTecnicaById_pdf = async (id) => {
    try {
      const response = await getVisitaTecnicaSostenibilidadById(id);
      const { status, data } = response;

      if (status) {
        setInitialData(data);
        setShowPdfVisitasTecnicas(true); // Abre el modal
      } else {
        notification.error({
          message: "Error",
          description:
            typeof response.message === "string"
              ? response.message
              : "Failed to fetch visita técnica data.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    }
  };
  useEffect(() => {
    fetchVisitasTecnicas();
  }, []);

  useEffect(() => {
    if (!visitasTecnicas || visitasTecnicas.length === 0) {
      setDepartamentos([]);
      setSelectedDepartamento(null);
      setFilteredData([]);
      return;
    }

    // Obtener lista única de departamentos de las visitas técnicas
    const uniqueDepartamentos = [
      ...new Set(visitasTecnicas.map((p) => p.departamento)),
    ].sort();
    setDepartamentos(uniqueDepartamentos);
    setSelectedDepartamento(null);

    // Obtener lista única de modalidad de las visitas técnicas
    const uniqueModalidad = [
      ...new Set(visitasTecnicas.map((p) => p.modalidad)),
    ].sort();
    setModalidad(uniqueModalidad);
    setFilteredData(visitasTecnicas);
  }, [visitasTecnicas]);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
    filterData(
      selectedDepartamento,
      selectedMunicipio,
      value,
      selectedModalidad
    );
  };

  const filterData = (departamento, municipio, texto, modalidad) => {
    let filtered = [...visitasTecnicas];
    // Filtro por departamento (si está seleccionado en el select)
    if (departamento) {
      filtered = filtered.filter((v) => v.departamento === departamento);
    }
    // Filtro por municipio (si está seleccionado en el select)
    if (municipio) {
      filtered = filtered.filter((v) => v.municipio === municipio);
    }

    // Filtro por modalidad (si está seleccionado en el select)
    if (modalidad) {
      filtered = filtered.filter((v) => v.modalidad === modalidad);
    }

    if (texto?.trim()) {
      // Verifica que no sea nulo, vacío o solo espacios
      filtered = filtered.filter((visitaTecnica) =>
        Object.values(visitaTecnica).some(
          (val) =>
            typeof val === "string" &&
            val.toLowerCase().includes(texto.toLowerCase())
        )
      );
    }

    // Actualiza los datos filtrados
    setFilteredData(filtered);
  };

  const handleClearFilters = () => {
    setSelectedDepartamento(null);
    setSelectedMunicipio(null);
    setSearchText("");
    setFilteredData(visitasTecnicas);
    setSelectedModalidad(null);
  };

  const handleDepartamentoChange = (value) => {
    setSelectedDepartamento(value);
    setSelectedMunicipio(null); // Resetear municipio cuando cambia departamento

    // Obtener municipios del departamento seleccionado
    const municipiosFiltrados = [
      ...new Set(
        visitasTecnicas
          .filter((p) => p.departamento === value)
          .map((p) => p.municipio)
      ),
    ].sort();
    setMunicipios(municipiosFiltrados);

    // Filtrar datos
    filterData(value, null, searchText, selectedModalidad);
  };

  const handleModalidadChange = (value) => {
    setSelectedModalidad(value);
    // Filtrar datos
    filterData(selectedDepartamento, selectedMunicipio, searchText, value);
  };

  const handleMunicipioChange = (value) => {
    setSelectedMunicipio(value);
    filterData(selectedDepartamento, value, searchText, selectedModalidad);
  };

  const columns = [
    {
      title: "Acciones",
      key: "acciones",
      ellipsis: true,
      fixed: "left",
      width: 100,
      render: (text, record) => (
        <Space>
          {permissionUpdate && (
            <Tooltip title="Editar Visita Técnica">
              <Button
                style={{ backgroundColor: "#FFA500", color: "#fff" }}
                icon={<EditOutlined />}
                onClick={() => {
                  fetchVisitaTecnicaById_update(record.id);
                }}
              ></Button>
            </Tooltip>
          )}
          {permissionPrint && (
            <Tooltip title="Descargar PDF">
              <Button
                type="default"
                icon={<FilePdfOutlined />}
                style={{ backgroundColor: "#1890ff", color: "#fff" }}
                onClick={() => {
                  fetchVisitaTecnicaById_pdf(record.id);
                }}
              ></Button>
            </Tooltip>
          )}
        </Space>
      ),
    },
    {
      title: "Fecha registro",
      dataIndex: "fecha_registro",
      key: "fecha_registro",
      width: 130,
      align: "center",
    },
    {
      title: "Número de visita",
      dataIndex: "numero_visita",
      key: "numero_visita",
      width: 120,
      align: "center",
    },
    {
      title: "Código interno",
      dataIndex: "codigo_interno",
      key: "codigo_interno",
      width: 120,
    },
    
    {
      title: "Modalidad",
      dataIndex: "modalidad",
      key: "modalidad",
      width: 120,
    },
    {
      title: "Departamento",
      dataIndex: "departamento",
      key: "departamento",
      width: 150,
    },
    {
      title: "Municipio",
      dataIndex: "municipio",
      key: "municipio",
      width: 150,
    },
    {
      title: "Código PREPP",
      dataIndex: "codigoPREPP",
      key: "codigoPREPP",
      width: 150,
    },
    {
      title: "Linea productiva",
      dataIndex: "linea_productiva",
      key: "linea_productiva",
      width: 150,
    },
    {
      title: "Nombre del proyecto",
      dataIndex: "nombreProyecto",
      key: "nombreProyecto",
      width: 150,
      ellipsis: true, // Permite el truncamiento del texto
      render: (text) => (
        <Tooltip title={text}>
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "block",
              width: "150px",
            }}
          >
            {text}
          </span>
        </Tooltip>
      ),
    },
  ];

  // ✅ Sin localStorage: el estado vive en memoria React, estable ante rotación
  const handleOpenModal = () => {
    setShowFormModal(true);
  };

  const handleCloseModal = () => {
    setShowFormModal(false);
  };



  return (
    <>
      {/*
       * ✅ PATRÓN VISTA DE PÁGINA (Page View Pattern)
       * En lugar de Modal o Drawer, el formulario reemplaza la tabla en el mismo árbol de render.
       * Ventajas:
       *  - No se desmonta ni reinicia al rotar el dispositivo.
       *  - El estado del formulario (Form.useForm) se mantiene estable.
       *  - Sin cálculos de viewport: usa el flujo normal del documento.
       *  - Mejor UX en móvil: pantalla completa, sin overlays.
       */}
      {showFormModal ? (
        <div
          style={{
            backgroundColor: "#f0f2f5",
            minHeight: "100vh",
            paddingBottom: 48,
          }}
        >
          {/* ── Franja sticky de fondo completo ── */}
          <div
            style={{
              position: "sticky",
              top: 0,
              zIndex: 100,
              backgroundColor: "#f0f2f5",
              borderBottom: "1px solid #dde3ec",
              boxShadow: "0 2px 10px rgba(4,41,86,0.07)",
              paddingTop: 16,
              paddingBottom: 16,
            }}
          >
            {/* Barra de navegación alineada con el card */}
        <div
  style={{
    maxWidth: 1100,
    margin: "0 auto",
    padding: "0 16px",
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: isMobile ? 12 : 0,
  }}
>
  {/* Botón volver */}
  <Button
    onClick={handleCancel}
    icon={<span style={{ fontSize: 16 }}>‹</span>}
    style={{
      width: isMobile ? "100%" : "auto",
      display: "flex",
      alignItems: "center",
      justifyContent: isMobile ? "center" : "flex-start",
      gap: 6,
      height: 36,
      paddingInline: 16,
      fontWeight: 600,
      fontSize: 13,
      color: "#042956",
      backgroundColor: "#fff",
      border: "1.5px solid #d0d9e8",
      borderRadius: 8,
      boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
    }}
  >
    Volver a la lista
  </Button>

  {/* Título */}
  <div
    style={{
      textAlign: "center",
      width: isMobile ? "100%" : "auto",
      margin: isMobile ? 0 : "0 16px",
    }}
  >
    <span
      style={{
        fontWeight: 700,
        fontSize: 15,
        color: "#042956",
        letterSpacing: 0.2,
        display: "block",
        width: "100%",
      }}
    >
      {initialData && Object.keys(initialData).length > 0
        ? "✏️  Editar visita técnica"
        : "➕  Nueva visita técnica"}
    </span>
  </div>

  {/* Espaciador solo en desktop */}
  {!isMobile && <div style={{ width: 148 }} />}
</div>

          </div>

          {/* Contenedor centrado con ancho máximo y margen superior */}
          <div
            style={{
              maxWidth: 1100,
              margin: "28px auto 0 auto",
              padding: "0 16px",
            }}
          >
            <Card
              bordered={false}
              style={{
                borderRadius: 12,
                boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
                overflow: "hidden",
              }}
              bodyStyle={{ padding: 0 }}
            >
              <FormularioVisitaTecnicaSostenibilidad
                initialData={initialData}
                onClose={handleCloseModal}
                fetchData={fetchVisitasTecnicas}
              />
            </Card>
          </div>
        </div>
      ) : showForm ? (
        <div className="form-container">
          <FormularioVisitaTecnicaSostenibilidad initialData={{}} />{" "}
          {/* Pasa un objeto vacío para la creación */}
        </div>
      ) : showPdfVisitasTecnicas ? (
        <PdfVisitaTecnicaSostenibilidad
          formData={initialData}
          onClose={() => setShowPdfVisitasTecnicas(false)} // Función para cerrar el componente
        />
      ) : (
        <>
          {/* Aquí va el resto del contenido que deseas mostrar cuando no se está creando una novedad */}
          {loading ? (
            <div className="text-center">
              <Spin size="large" />
            </div>
          ) : (
            <>
              <div className="container">
                <div style={{ padding: "20px" }}>
                  <Header166 type="s_vt" />
                  <Row gutter={[16, 16]} className="mb-4">
                    <Col span={24}>
                      <div className="filter-container">
                        <Row gutter={[16, 16]} align="middle">
                          {/* Filtro Departamento */}
                          <Col xs={24} sm={12} md={5} lg={3}>
                            <div className="filter-item">
                              <Title
                                level={5}
                                className="filter-label"
                                style={{ color: "#042956" }}
                              >
                                Departamento
                              </Title>
                              <Select
                                style={{ width: "100%" }}
                                placeholder="Seleccione departamento"
                                allowClear
                                onChange={handleDepartamentoChange}
                                value={selectedDepartamento}
                                showSearch
                                optionFilterProp="children" // busca dentro del texto de las opciones
                              >
                                {departamentos.map((depto) => (
                                  <Select.Option key={depto} value={depto}>
                                    {depto}
                                  </Select.Option>
                                ))}
                              </Select>
                            </div>
                          </Col>

                          {/* Filtro Municipio */}
                          <Col xs={24} sm={12} md={5} lg={3}>
                            <div className="filter-item">
                              <Title
                                level={5}
                                className="filter-label"
                                style={{ color: "#042956" }}
                              >
                                Municipio
                              </Title>
                              <Select
                                style={{ width: "100%" }}
                                placeholder="Seleccione municipio"
                                allowClear
                                disabled={!selectedDepartamento}
                                onChange={handleMunicipioChange}
                                value={selectedMunicipio}
                                showSearch
                                optionFilterProp="children" // busca dentro del texto de las opciones
                              >
                                {municipios.map((muni) => (
                                  <Select.Option key={muni} value={muni}>
                                    {muni}
                                  </Select.Option>
                                ))}
                              </Select>
                            </div>
                          </Col>

                          {/* Filtro Modalidad */}
                          <Col xs={24} sm={12} md={5} lg={3}>
                            <div className="filter-item">
                              <Title
                                level={5}
                                className="filter-label"
                                style={{ color: "#042956" }}
                              >
                                Modalidad
                              </Title>
                              <Select
                                style={{ width: "100%" }}
                                placeholder="Seleccione departamento"
                                allowClear
                                onChange={handleModalidadChange}
                                value={selectedModalidad}
                                showSearch
                                optionFilterProp="children" // busca dentro del texto de las opciones
                              >
                                {modalidad.map((m) => (
                                  <Select.Option key={m} value={m}>
                                    {m}
                                  </Select.Option>
                                ))}
                              </Select>
                            </div>
                          </Col>

                          {/* Barra de búsqueda */}
                          <Col xs={24} sm={12} md={7} lg={4}>
                            <div className="filter-item">
                              <Title
                                level={5}
                                className="filter-label"
                                style={{ color: "#042956" }}
                              >
                                Búsqueda
                              </Title>
                              <Input
                                placeholder="Buscar..."
                                prefix={<SearchOutlined />}
                                value={searchText}
                                onChange={handleSearch}
                              />
                            </div>
                          </Col>

                          {/* Botón Limpiar */}
                          <Col xs={12} sm={6} md={3} lg={1}>
                            <Button
                              type="primary"
                              onClick={handleClearFilters}
                              icon={<ClearOutlined />}
                              style={{ width: "100%", marginTop: "24px" }}
                              disabled={
                                !(
                                  selectedDepartamento ||
                                  searchText ||
                                  selectedMunicipio ||
                                  selectedModalidad
                                )
                              }
                            >
                              {" "}
                            </Button>
                          </Col>

                          <Col xs={12} sm={6} md={3} lg={1}>
                            <Button
                              type="primary"
                              onClick={fetchVisitasTecnicas}
                              icon={<ReloadOutlined />}
                              style={{ width: "100%", marginTop: "24px" }}
                            >
                              {" "}
                            </Button>
                          </Col>
                          {/* Botón Exportar data */}
                          {permissionExport && (
                            <Col
                              xs={12}
                              sm={6}
                              md={3}
                              lg={3}
                              style={{
                                marginTop: "24px",
                                borderColor: "#52c41a",
                              }}
                            >
                              <ExportVisitasTecnicasSostenibilidad
                                dataCompleta={filteredData}
                              ></ExportVisitasTecnicasSostenibilidad>
                            </Col>
                          )}

                          {/* Botón Crear visita tecnica */}
                          <Col xs={12} sm={6} md={3} lg={3}>
                            {permissionInsert && (
                              <Button
                                type="primary"
                                style={{
                                  marginTop: "24px",
                                  backgroundColor: "#52c41a",
                                  borderColor: "#52c41a",
                                }}
                                icon={<PlusOutlined />}
                                onClick={() => {
                                  setInitialData({}); // Restablece initialData para crear una nueva novedad
                                  handleOpenModal(); // Abre el modal
                                }}
                              >
                                Nuevo
                              </Button>
                            )}
                          </Col>

                          {/* Total */}
                          <Col xs={12} sm={6} md={3} lg={3}>
                            <Card
                              size="small"
                              style={{
                                marginTop: "24px",
                                textAlign: "center",
                                backgroundColor: "#f0f5ff", // Fondo azul claro
                              }}
                            >
                              <Statistic
                                title="Total Visitas"
                                value={filteredData.length}
                                valueStyle={{
                                  color: "#1890ff",
                                  fontWeight: "bold",
                                }}
                              />
                            </Card>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>

                  <div className="row mb-4">
                    <div className="col-12">
                      {filteredData.length > 0 ? (
                        <Table
                          columns={columns}
                          dataSource={filteredData}
                          rowKey="id"
                          bordered
                          scroll={{ y: 500, x: "max-content" }}
                          pagination={{
                            current: currentPage, // página actual
                            pageSize: pageSize, // filas por página
                            total: filteredData.length, // total de registros
                            showSizeChanger: true,
                            pageSizeOptions: ["10", "20", "50", "100"],
                            showTotal: (total, range) =>
                              `${range[0]}-${range[1]} de ${total} registros`,
                            onChange: (page, size) => {
                              setCurrentPage(page);
                              setPageSize(size);
                            },
                          }}
                        />
                      ) : (
                        <div style={{ textAlign: "center", margin: "20px" }}>
                          <Alert
                            message="No hay resultados"
                            description="No se encontraron visitas técnicas que coincidan con tu búsqueda."
                            type="info"
                            showIcon
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
      {/* ✅ Modal/Drawer eliminados: el formulario se renderiza como vista de página arriba */}
    </>
  );
};

export default TablaVisitaTecnicaSostenibilidad;